import { Utils, EventBus } from '../../app.base';
import { Routes, MsgBox } from '../../app.vues';
//
import merchtComnApi from '../../api/merchtComn';

export function getMerchantBizParam(code, callback, level, bizUnitId, realComId) {
    let postData = {};
    postData.code = code;  //
    postData.level = level;  // 参数级别 2：公司级
    postData.bizUnitId = bizUnitId;  // 后台用于查找实体公司
    postData.realComId = realComId;  // 实体公司
    merchtComnApi.getMerchantBizParamValue(postData, function (result) {
        if(result.type === "info") {
            callback(result.data);
        } else {
            MsgBox.warning(result.message);
        }
    });
}
export function getRealCtrlParam(code, callback) {
    let postData = {};
    postData.code = code;  //
    merchtComnApi.getRealCtrlParamValue(postData, function (result) {
        if(result.type === "info") {
            callback(result.data);
        } else {
            MsgBox.warning(result.message);
        }
    });
}
// 调拨、报废、清理、是否可操作
export function checkMerchtBizParamExecut(callback) {
    // 是否每月自动计算资产折旧、净值
    getMerchantBizParam("auto.calc.asset.worth.values.monthly", function (autoCalcAssetWorth) {
        if(Utils.isTrue(autoCalcAssetWorth)) {
            // 折旧日禁止财务变动业务（调拨、报废、清理等）
            getMerchantBizParam("disable.asset.fiscal.biz.on.depr.day", function (disableAssetFiscal) {
                if(Utils.isTrue(disableAssetFiscal)) {
                    // 每月自动计算资产折旧、净值日期：xx 号
                    getMerchantBizParam("auto.calc.asset.worth.values.at.date", function (autoCalcAssetWorthDate) {
                        if(!Utils.isNoB(autoCalcAssetWorthDate) && autoCalcAssetWorthDate == new Date().getDate()) {
                            callback(false);
                        } else {
                            callback(true);
                        }
                    });
                } else {
                    callback(true);
                }
            });
        } else {
            callback(true);
        }
    });
}






//////////////////
// WEBPACK FOOTER
// ./src/compo/asset/assetMain.js
// module id = 21
// module chunks = 0